import React, {useState} from 'react';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
export default function ESimInfo(props) {
  console.log(props);
  const [whatIsEsimPopup, setWhatIsEsimPopup] = useState(false);
  return (
    <div className='d-flex flex-column justify-content-start'>
      <span style={{fontSize: '18px', color: '#757475', marginBottom: '14px'}}>יש לוודא שהמכשיר שלכם תומך ב-eSIM</span>
      <a
        onClick={() => setWhatIsEsimPopup(true)}
        target='_blank'
        style={{cursor: 'pointer', fontSize: '18px', color: 'var(--theme-primary, #9631ff)', marginBottom: '14px'}}>
        מה זה eSIM?
      </a>
      <a href={props?.cellularDevicesSupportedUrl} target='_blank' style={{cursor: 'pointer', fontSize: '18px', color: 'var(--theme-primary, #9631ff)'}}>
        האם המכשיר שלי תומך ב-eSIM?
      </a>
      <PopUp showPopUp={whatIsEsimPopup} onClose={() => setWhatIsEsimPopup(false)} className='popup-esim-details'>
        <h1>מה זה eSIM?</h1>
        <div className='esim-description-text' dangerouslySetInnerHTML={{__html: props.whatIsEsimPopupTextList}}></div>

        <BtnSubmit
          isBusiness={false}
          text={'סגור'}
          onclick={() => {
            setWhatIsEsimPopup(false);
          }}
          formid={'popup-esim-details'}
          isDisplayArrows={false}
        />
      </PopUp>
    </div>
  );
}
